export default __webpack_public_path__ + "static/media/pamet.db35509b.svg";